import { render, staticRenderFns } from "./products.vue?vue&type=template&id=09b54d10&scoped=true"
import script from "./products.vue?vue&type=script&lang=js"
export * from "./products.vue?vue&type=script&lang=js"
import style0 from "./products.vue?vue&type=style&index=0&id=09b54d10&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b54d10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b54d10')) {
      api.createRecord('09b54d10', component.options)
    } else {
      api.reload('09b54d10', component.options)
    }
    module.hot.accept("./products.vue?vue&type=template&id=09b54d10&scoped=true", function () {
      api.rerender('09b54d10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/products.vue"
export default component.exports